import deepMerge from 'deepmerge';
import { DefaultTheme } from 'styled-components';
import { ThemeOverride } from './types';
import colors from './colors';

/* eslint-disable max-len */
const defaults: Partial<DefaultTheme> = {
  breakpoints: {
    mobile: 'only screen and (max-width: 599px)',
    touch: 'only screen and (max-width: 1024px)',
    tablet: 'only screen and (min-width: 600px) and (max-width: 1024px)',
    tabletMax: 'only screen and (max-width: 767px)',
    tabletMin: 'only screen and (min-width: 768px)',
    desktop: 'only screen and (min-width: 1025px)',
    wide: 'only screen and (min-width: 1240px)',
    mobileLayoutPortrait: 'only screen and (min-width: 1px) and (max-width: 599px)',
    mobileLayoutLandscape: 'only screen and (min-width: 1px) and (max-width: 812px) and (orientation: landscape)',
    tabletLayoutPortrait: 'only screen and (min-width: 600px) and (max-width: 1024px)',
    tabletLayoutLandscape: 'only screen and (min-height: 600px) and (max-height: 1024px) and (orientation: landscape)',
    desktopLayout: 'only screen and (min-width: 1025px)',
    gteDesktop: 'only screen and (min-width: 1025px)',
    gteTablet: 'only screen and (min-width: 768px)',
    mobileMin: 'only screen and (min-width: 600px)',
    smallMobileMin: 'only screen and (min-width: 480px)',
    mediaSmallTablet: 'only screen and (min-width: 600px) and (max-width: 800px)'
  },
  colors: colors,
  fonts: {
    default: {
      fontFamily: 'Helvetica, Arial, sans-serif',
      fontSize: '13px',
      lineHeight: 1.231,
      color: colors.shades[2]
    }
  },
  fontWeights: {
    normal: 'normal',
    bold: 'bold'
  },
  spacing: [
    0,
    '5px',
    '10px',
    '15px',
    '20px'
  ]
};

export const overrideDefaultTheme = (overrides: ThemeOverride) => deepMerge(defaults, overrides);

export default defaults;
